import * as api from '../../api/api-carta-cia-modal';
import { 
    GET_CONFIG_FORM25,
    GET_DATOS_IMPLICADO
    
} from '../types';

export const configuracionFormAction25 = (query) => ({
    type: GET_CONFIG_FORM25,
    payload: api.getConfiguracionForm25(query)
});
export const obtenerDatosImplicado = (query) => ({
    type: GET_DATOS_IMPLICADO,
    payload: api.getDatosImplicado(query)
});